import { getRequest } from '../_helpers/fetch-wrapper';
import { buildRequestHeader, getAuthApiBaseUrl, tokenControl } from '../core/utility';

export const getUserRoleClaims = async (): Promise<Array<string>> => {
    await tokenControl();

    const urlSuffix = `/roles/claims/user`;
    const url = String(getAuthApiBaseUrl() + urlSuffix);

    try {
        const userRoleClaimsResponse: Response = await getRequest(url, {
            headers: {
                ...buildRequestHeader(),
            },
        });
        const response: any = await userRoleClaimsResponse;
        return response.result as Array<string>;
    } catch (err) {
        window.location.href = '/autWarning';

        //!401 control
        // if(err.error.status===401){
        //     handleErrorType(401);

        // }
    }

    // const userRoleClaimsResponse: Response = await getRequest(url, {
    //     headers: {
    //         ...buildRequestHeader(),
    //     },
    // });
    // const response: any = await userRoleClaimsResponse;

    // if (response?.isSuccessful) {
    //     return response.result as Array<string>;
    // } else {
    //     console.log('aaaaa');

    // handleErrorType(userRoleClaimsResponse?.status);
    // }

    return [];
};
